import axios from 'axios'
import VueCookies from 'vue-cookies'

const http = axios.create({
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  },
	//为了在调试环境自动开启代理以便跨域，调试环境添加默认前缀
	baseURL: process.env.NODE_ENV === 'development' ? '/proxyaiapi/' : window.SITE_CONFIG.aiReadUrl,
})


/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  //console.log("请求头token:"+config.headers['token']+" cookie token:"+Vue.cookie.get('token'));
  // config.headers['token'] = Vue.cookie.get('token') // 请求头带上token
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  if (response.data && response.data.code === 40001) { // 40001, token失效
    // console.log("token失败拦截:"+JSON.stringify(response.data));
    // clearLoginInfo()
    // router.push({ name: 'login' })
		// if(response.data.url){
		// 	window.location.href=response.data.url;
		// }
		alert("您未登录，请登录后查看！");
		VueCookies.set('unlogin','1');
		window.location.href='/';
  }
	else if (response.data && response.data.code === 40002){ // 40002, 未订购
		// console.log("未订购拦截:"+JSON.stringify(response.data));
		alert("您当前登录账户未订购此产品！");
		window.location.href='/';
	}
	else{
		return response
	}
}, error => {
  return Promise.reject(error)
})


export default http